import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs';
import { LangTranslator } from '../translator/langtranslator';

@Component({
  selector: 'app-principal-header',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './principal-header.html',
  styleUrl: './principal-header.scss',
})
export class PrincipalHeader {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private readonly translator = inject(LangTranslator);

  constructor(private location: Location) {}

  private routerEvents = toSignal(this.router.events);

  showBackButton = computed(() => {
    this.routerEvents();
    const url = this.router.url;
    const segments = url.split('/').filter(Boolean);
    return segments.length > 1;
  });
  goBack() {
    this.location.back();
  }
  title = computed(() => {
    this.routerEvents();
    this.translator.currentLang(); 
    const titleKey = this.route.snapshot.firstChild?.data['headerTitle'] ?? '';
    return this.translator.translate(titleKey);
  });

  subtitle = toSignal(this.route.data.pipe(
    map(d => d['vessel']?.name)
  ));
}
